<!--
  This icon is designed especially for Dierenbescherming and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M1.3 23.4c0 .1.1.2.2.2 1 .1 2.1.3 3.1.2H5s.3-.3.2-.4c.1-.4.1-.8.3-1.3.3-.6.6-1.1.9-1.7l.8-1.2c1 .7 2.7.7 3.8 1.3.5.3.9.6 1.4.9.2.1.7.3.9.6-.4-.1-.7-.1-1.1 0h-1.4c-.7 0-1.2.9-.9 1.5.2.5.8.5 1.3.5h2.4c.9 0 1.9-.1 2.8-.3.2 0 .4-.1.6-.2.1-.1.3-.2.4-.3.4-.1.9.3 1.2.4.7.3 1.3.3 2.1.2.6-.1 1.3-.2 1.6-.8 1.6-3.2-2.2-1.7-2.1-2 .6-1.3.8-1.7 1-2.5.2-1.1 0-2.4-.4-3.5-.3-1-.9-1.9-1.6-2.7-.8-.9-1.8-1.4-2.9-1.9-1.3-.5-2.7-.5-4.1-.7-.7-.1-1.3-.2-2-.4-.4.1-1-.1-1.4-.5-.8-.8-.5-2.3 0-3.2.3-.6.8-1 1.3-1.5.4-.4.7-.8.9-1.4.1-.5 0-1.1 0-1.7 0-.3.1-.7-.4-.9h-.2c-.4 0-.9.4-1.2.7-.4.3-.6.7-.9 1.1 0-.4 0-2.3-.7-1.8-.8.5-1.5 1.5-1.9 2.3-.5.8-.2 1.7-.3 2.6-.8 0-1.4.4-2 .9-.3.3-.5.6-.7.9-.2.4-.6.7-.9 1-.5.6-.8 1.3-.3 2 .3.4.7.6 1.2.7-.5 1.3-.8 2.8-.2 4.1.6 1.3 1.9 2.7 1.9 3.6 0 .5 0 1.3-.3 1.7-.4.6-.7 1.3-.9 1.9-.2.5-.7.3-1.1.5-.5.2-.9.6-.8 1.1z"
    />
  </svg>
</template>
